// Anropen mot kom igång-statusen.
//
// Läsningen sväljer 404 och 501 och svarar med ett tomt framsteg: gränssnittet byggs före
// endpointen, och ett helt okryssat läge är exakt det en ny organisation ska se ändå. Samma
// hållning som utlåningspoolens `tystOmSaknad` (se ALLMÄNNINGEN.md) och av samma skäl — en
// halvbyggd backend ska inte ge ett trasigt block, bara en lista som inte är ifylld.
//
// Skrivningen sväljer ingenting. En avbockning som inte gick fram måste användaren få veta om,
// annars tror hela styrelsen att steget är gjort.

import axiosInstance, { endpoints } from 'src/lib/axios';

import { ärEjByggdEndpoint } from 'src/sections/utlåningspool/utlåningspool-fel';

import type { KomIgångStatus } from './kom-igang-typer';

// ----------------------------------------------------------------------

export const TOMT_FRAMSTEG: KomIgångStatus = { härledda: [], avbockade: [] };

export async function hämtaKomIgångStatus(): Promise<KomIgångStatus> {
  try {
    const svar = await axiosInstance.get<KomIgångStatus>(endpoints.komIgång.status);
    return {
      härledda: svar.data?.härledda ?? [],
      avbockade: svar.data?.avbockade ?? [],
    };
  } catch (fel) {
    if (ärEjByggdEndpoint(fel)) {
      return TOMT_FRAMSTEG;
    }
    throw fel;
  }
}

/** Bockar av eller ångrar ett steg. Svaret är hela den nya statusen. */
export async function sättAvbockning(stegId: string, avbockad: boolean): Promise<KomIgångStatus> {
  const svar = await axiosInstance.put<KomIgångStatus>(endpoints.komIgång.steg(stegId), {
    avbockad,
  });
  return {
    härledda: svar.data?.härledda ?? [],
    avbockade: svar.data?.avbockade ?? [],
  };
}
